import React, { Component } from 'react'; 
import _ from 'lodash';
import {Modal, FormGroup, FormLabel, Accordion, Card, Button, FormControl, ModalTitle} from 'react-bootstrap'
import '../../Resources/css/Inventory.css';


export default class InventoryFile extends Component { 
  constructor(props){
    super(props)
    this.state={
      showregions:false,
      regionvalue:[{'label':'', 'status':'ACTIVE'}],
      centervalue:[{'label':'', 'status':'ACTIVE'}],
      clientvalue:[{'label':'', 'status':'ACTIVE'}],
      processvalue:[{'label':'', 'status':'ACTIVE'}],
      categoriesValue:[{'label':'', 'status':'ACTIVE'}],
    }
  }
  componentDidMount(){
		this.props.action.actioninventoryMaster()
  }	
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.action.showModalLogin, this.props.action.showModalLogin) && nextProps.action.showModalLogin === false){     
      this.props.action.actioninventoryMaster()
    }
  }  
  regionNames = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
    let regionNames = masterinventory.regions
    if(!_.isEmpty(regionNames)){
      let regionUI = _.map(regionNames, (obj, i) => {
        return(
          <div><span id={obj.id} value={obj.label} onDoubleClick={(e)=>this.editPerson(e, i, 'regions')}
        className={(obj.status === 'INACTIVE') ? 'newWModalClass disabled' : 'newWModalClass'}>
        {this.state['editregions'+i] ? 
          <input type='text' onBlur={()=>this.editFalseRegions(i, 'regions', obj)} 
          value={(typeof this.state['labelregions'+i] !== 'undefined') ?
          this.state['labelregions'+i] : obj.label} onChange={(e)=>this.handleChangeEditing(e, i, 'regions')} />  : this.state['label'+i] ?
          this.state['labelregions'+i] : obj.label} </span>
      {(obj.status === 'INACTIVE') ? 
            <i class="fas fa-check  accord" onClick={()=> this.handleActiveRegions(obj)}/>  :
            <i class="fas fa-times-circle accord" onClick={()=> this.handleDeleteRegions(obj)}/> }</div>
        )
      });  
      return regionUI;
    }
    }
  }
  handleShow = (prop) => {
    this.setState({['show'+prop]:true})    
  }  
  handleHide = (prop) => {
      this.setState({ ['show'+prop]: false });
      
  }
  addMoreRegions = () => {        
    const{regionvalue}= this.state;
    regionvalue.push({label:'', status:'ACTIVE'})
    this.setState({regionvalue});
  }
  UpDateRegionName = () => {    
    this.setState({showregions:false});    
    const{regionvalue} = this.state; 
    _.remove(regionvalue, {"label":""})
    this.props.action.actioninventoryMasteraddData('region', regionvalue, 'regions')    
    this.setState({regionvalue:[]})        
  }
  handleOptionChange= (e, i) => {			
    const{regionvalue} = this.state;
    let id;
    if(!_.isEmpty(this.props.masterinventory) && !_.isEmpty(this.props.masterinventory.regions)){ 
     id  = _.findLast(this.props.masterinventory.regions).id
    } else {
     id = 0    
    }
    let lastindex = _.findLastIndex(regionvalue) 
    regionvalue[i].label = e.target.value;
    regionvalue[i]['id'] = id+1+lastindex
     this.setState({regionvalue});     
  }
  editFalseRegions = (i,prop, obj) => {
    this.setState({['edit'+prop+i]:false})
   this.props.action.actioninventoryMasterUpdate(i, this.state['labelregions'+i], 'region', obj, 'regions')
  }
  handleActiveRegions = (obj) => {  
    this.props.action.actioninventoryMasterEdit(obj, 'ACTIVE', 'region', 'regions');
 }
  handleDeleteRegions = (obj) => {
    this.props.action.actioninventoryMasterEdit(obj, 'INACTIVE', 'region', 'regions');
  }
  editFalseCenters = (i,prop, obj) => {
    this.setState({['edit'+prop+i]:false})
   this.props.action.actioninventoryMasterUpdate(i, this.state['labelcenters'+i], 'center', obj, 'centers')
  }
  handleActiveCenters = (obj) => {  
    this.props.action.actioninventoryMasterEdit(obj, 'ACTIVE', 'center', 'centers');
 }
  handleDeleteCenters = (obj) => {
    this.props.action.actioninventoryMasterEdit(obj, 'INACTIVE', 'center', 'centers');
  }
  centerNames = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
    let centerNames = masterinventory.centers
    if(!_.isEmpty(centerNames)){
     let regionUI = _.map(centerNames, (obj, i) => {
      return(
        <div><span id={obj.id} value={obj.label} onDoubleClick={(e)=>this.editPerson(e, i, 'centers')}
      className={(obj.status === 'INACTIVE') ? 'newWModalClass disabled' : 'newWModalClass'}>
      {this.state['editcenters'+i] ? 
        <input type='text' onBlur={()=>this.editFalseCenters(i, 'centers', obj)} value={(typeof this.state['labelcenters'+i] !== 'undefined') ?
        this.state['labelcenters'+i] : obj.label} onChange={(e)=>this.handleChangeEditing(e, i, 'centers')} />  : this.state['label'+i] ?
        this.state['labelcenters'+i] : obj.label} </span>
     {(obj.status === 'INACTIVE') ? 
          <i class="fas fa-check  accord" onClick={()=> this.handleActiveCenters(obj)}/>  :
          <i class="fas fa-times-circle accord" onClick={()=> this.handleDeleteCenters(obj)}/> }</div>
      )
    });  
    return regionUI;
    }
    }
  }
  
  addMoreCenters = () => {        
    const{centervalue}= this.state;
    centervalue.push({label:'', status:'ACTIVE'})
    this.setState({centervalue});
  }
  UpDateCenterName = () => {    
    this.setState({showcenters:false});    
    const{centervalue} = this.state;
    _.remove(centervalue, {"label":""})
    this.props.action.actioninventoryMasteraddData('center', centervalue, 'centers')   
    this.setState({centervalue:[]})       
  }
  handleOptionChangeCenter= (e, i) => {			
    const{centervalue} = this.state;
    let id;
    if(!_.isEmpty(this.props.masterinventory) && !_.isEmpty(this.props.masterinventory.centers)){
      id  = _.findLast(this.props.masterinventory.centers).id
    } else {
      id = 0 
    }
    let lastindex = _.findLastIndex(centervalue)
    centervalue[i].label = e.target.value;
    centervalue[i]['id'] = id+1+lastindex
     this.setState({centervalue});  
     
  }
  editFalseprocess = (i,prop, obj) => {
    this.setState({['edit'+prop+i]:false})
    this.props.action.actioninventoryMasterUpdate(i, this.state['labelprocess'+i], "PROCESS", obj, 'processes')
  }
  handleActiveprocess = (obj) => {  
    this.props.action.actioninventoryMasterEdit(obj, 'ACTIVE', "PROCESS", 'processes');
 }
 handleDeleteprocess = (obj) => {
    this.props.action.actioninventoryMasterEdit(obj, 'INACTIVE', "PROCESS", 'processes');
  }

  processNames = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
    let processesNames = masterinventory.processes
    if(!_.isEmpty(processesNames)){
    let regionUI = _.map(processesNames, (obj, i) => {
    return(
      <div><span id={obj.id} value={obj.label} onDoubleClick={(e)=>this.editPerson(e, i, 'process')}
    className={(obj.status === 'INACTIVE') ? 'newWModalClass disabled' : 'newWModalClass'}>
    {this.state['editprocess'+i] ? 
      <input type='text' onBlur={()=>this.editFalseprocess(i, 'process', obj)} value={(typeof this.state['labelprocess'+i] !== 'undefined') ?
      this.state['labelprocess'+i] : obj.label} onChange={(e)=>this.handleChangeEditing(e, i, 'process')} />  : this.state['label'+i] ?
      this.state['labelprocess'+i] : obj.label} </span>
    {(obj.status === 'INACTIVE') ? 
        <i class="fas fa-check  accord" onClick={()=> this.handleActiveprocess(obj)}/>  :
        <i class="fas fa-times-circle accord" onClick={()=> this.handleDeleteprocess(obj)}/> }</div>
    )
    });  
    return regionUI;
    }
    }
  }
  
  addMoreProcess = () => {        
    const{processvalue}= this.state;
    processvalue.push({label:'', status:'ACTIVE'})
    this.setState({processvalue});
  }
  UpDateProcessName = () => { 
    const{processvalue} = this.state;
    this.setState({showprocess:false}); 
    _.remove(processvalue, {"label":""})
    this.props.action.actioninventoryMasteraddData('PROCESS', processvalue, 'processes')
    this.setState({processvalue:[]})         
  }
 
  handleOptionChangeProcess= (e, i) => {			
    const{processvalue} = this.state;
    let id;
    if(!_.isEmpty(this.props.masterinventory) && !_.isEmpty(this.props.masterinventory.processes)){
      id  = _.findLast(this.props.masterinventory.processes).id
    } else {
      id = 0 
    }  
    let lastindex = _.findLastIndex(processvalue)
    processvalue[i].label = e.target.value;
    processvalue[i]['id'] = id+1+lastindex
    this.setState({processvalue});     
  }
  editPerson = (e, i, prop) => {
    this.setState({['edit'+prop+i]:true})
  }
  handleChangeEditing = (e, i, prop) => {
    this.setState({['label'+prop+i]:e.target.value})
  }
  editFalseClients = (i,prop, obj) => {
    if(!_.isEmpty(this.state['labelclients'+i])){
    this.setState({['edit'+prop+i]:false})
    this.props.action.actioninventoryMasterUpdate(i, this.state['labelclients'+i], 'client', obj, 'clients')
    }
  }
  handleActiveClients = (obj) => {  
    this.props.action.actioninventoryMasterEdit(obj, 'ACTIVE', 'client', "clients");
 }
  handleDeleteClients = (obj) => {
    this.props.action.actioninventoryMasterEdit(obj, 'INACTIVE', 'client', "clients");
  }
  clientNames = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
    let clientsNames = masterinventory.clients
    if(!_.isEmpty(clientsNames)){
    let regionUI = _.map(clientsNames, (obj, i) => {
      return (<div><span id={obj.id} value={obj.label} onDoubleClick={(e)=>this.editPerson(e, i, 'clients')}
      className={(obj.status === 'INACTIVE') ? 'newWModalClass disabled' : 'newWModalClass'}>
      {this.state['editclients'+i] ? 
        <input type='text' onBlur={()=>this.editFalseClients(i, 'clients', obj)} value={(typeof this.state['labelclients'+i] !== 'undefined') ?
        this.state['labelclients'+i] : obj.label} onChange={(e)=>this.handleChangeEditing(e, i, 'clients')} />  : this.state['label'+i] ?
        this.state['labelclients'+i] : obj.label} </span>
     {(obj.status === 'INACTIVE') ? 
          <i class="fas fa-check  accord" onClick={()=> this.handleActiveClients(obj)}/>  :
          <i class="fas fa-times-circle accord" onClick={()=> this.handleDeleteClients(obj)}/> }</div>);
    });  
    return regionUI;
    }
    }
  }
  addMoreClients = () => {        
    const{clientvalue}= this.state;
    clientvalue.push({label:'', status:'ACTIVE'})
    this.setState({clientvalue});
  }
  UpDateClientName = () => { 
    const{clientvalue} = this.state;
    this.setState({isClients:false}); 
    _.remove(clientvalue, {"label":""})
    this.props.action.actioninventoryMasteraddData('client', clientvalue, 'clients')
    this.setState({clientvalue:[]})         
  }
  handleOptionChangeClient= (e, i) => {			
    const{clientvalue} = this.state;
    let id;
    if(!_.isEmpty(this.props.masterinventory) && !_.isEmpty(this.props.masterinventory.clients)){
      id  = _.findLast(this.props.masterinventory.clients).id
    } else {
      id = 0  
    }
    let lastindex = _.findLastIndex(clientvalue)
    clientvalue[i].label = e.target.value;
    clientvalue[i]['id'] = id+1+lastindex
    this.setState({clientvalue}); 
     
  }
  
  editFalsecategories = (i,prop, obj) => {
    this.setState({['edit'+prop+i]:false})
    this.props.action.actioninventoryMasterUpdate(i, this.state['labelcategories'+i], 'CATEGORY', obj, 'categories')
  }
  handleActivecategories = (obj) => {  
    this.props.action.actioninventoryMasterEdit(obj, 'ACTIVE', 'CATEGORY','categories');
 }
 handleDeletecategories = (obj) => {
    this.props.action.actioninventoryMasterEdit(obj, 'INACTIVE', 'CATEGORY','categories');
  }
  Categories = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
    let categories = masterinventory.categories
    if(!_.isEmpty(categories)){    
    let regionUI = _.map(categories, (obj, i) => {
      return(
        <div><span id={obj.id} value={obj.label} onDoubleClick={(e)=>this.editPerson(e, i, 'categories')}
      className={(obj.status === 'INACTIVE') ? 'newWModalClass disabled' : 'newWModalClass'}>
      {this.state['editcategories'+i] ? 
        <input type='text' onBlur={()=>this.editFalsecategories(i, 'categories', obj)} value={(typeof this.state['labelcategories'+i] !== 'undefined') ?
        this.state['labelcategories'+i] : obj.label} onChange={(e)=>this.handleChangeEditing(e, i, 'categories')} />  : this.state['label'+i] ?
        this.state['labelcategories'+i] : obj.label} </span>
      {(obj.status === 'INACTIVE') ? 
          <i class="fas fa-check  accord" onClick={()=> this.handleActivecategories(obj)}/>  :
          <i class="fas fa-times-circle accord" onClick={()=> this.handleDeletecategories(obj)}/> }</div>
      )
    });  
    return regionUI;
    }
    }
  }
  addMoreCategories = () => {        
    const{categoriesValue}= this.state;
    categoriesValue.push({label:'', status:'ACTIVE'})
    this.setState({categoriesValue});
  }
  UpDateCategories = () => { 
    const{categoriesValue} = this.state;
    this.setState({showCatagories:false}); 
    _.remove(categoriesValue, {"label":""})
    this.props.action.actioninventoryMasteraddData('CATEGORY', categoriesValue, 'categories')
    this.setState({categoriesValue:[]})         
  }
  handleOptionChangeCategories= (e, i) => {			
    const{categoriesValue} = this.state;
    let id;
    if(!_.isEmpty(this.props.masterinventory) && !_.isEmpty(this.props.masterinventory.categories)){
      id  = _.findLast(this.props.masterinventory.categories).id
    } else {
      id = 0
    }
    let lastindex = _.findLastIndex(categoriesValue)
    categoriesValue[i].label = e.target.value;
    categoriesValue[i]['id'] = id+1+lastindex;
     this.setState({categoriesValue});  
     
  }
  handleShowClients = () => {
    this.setState({isClients:true})
  }
  closeClients= () => {
    this.setState({isClients:false})
  }

  render(){
    const{regionvalue, showregions, showcenters, centervalue, showprocess, processvalue, categoriesValue, clientvalue} = this.state;
    if(_.isEmpty(regionvalue)){(regionvalue.push({'label':'', 'status':'ACTIVE'})) }
    if(_.isEmpty(centervalue)){centervalue.push({'label':'', 'status':'ACTIVE'}) }
    if(_.isEmpty(processvalue)){processvalue.push({'label':'', 'status':'ACTIVE'}) }
    if(_.isEmpty(categoriesValue)){categoriesValue.push({'label':'', 'status':'ACTIVE'}) }
    return(
    <div> 
      <Accordion>
        <Card>
        <Accordion.Toggle as={Card.Header} eventKey="0">
          Region
          <i class="fas fa-plus-circle accord" onClick={()=>this.handleShow('regions')}/>
           {showregions ?
              <Modal
              show={showregions}
              onHide={()=>this.handleHide('regions')}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              >
              <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Region
              </Modal.Title>
              </Modal.Header>  
              <Modal.Body>
              <p>             
              <FormGroup>
              { 
                _.map(regionvalue, (obj, index)=>{
                return(
                  <FormControl 
                  type='text'
                  onChange={(e)=>this.handleOptionChange(e, index)}
                  value={obj.label}
                  label={obj.label}																
                />
                )
                })
              }						
  
              <span className="cursorPointer" onClick={this.addMoreRegions}>Add More</span>
              </FormGroup>
              <Button className="cursorPointer"onClick={this.UpDateRegionName}>Add</Button>
              </p>
              </Modal.Body>
              </Modal>
            : null }
        </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
          <Card.Body>
          {this.regionNames()}
          
        </Card.Body>
        </Accordion.Collapse>
        </Card>
        <Card>
        <Accordion.Toggle as={Card.Header} eventKey="1">
          Center
          <i class="fas fa-plus-circle accord" onClick={()=>this.handleShow('centers')}/>        
          {showcenters ?
              <Modal
              show={showcenters}
              onHide={()=>this.handleHide('centers')}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              >
              <Modal.Header closeButton>
              <ModalTitle>  Center Name</ModalTitle> 
              </Modal.Header>  
              <Modal.Body>
              <p>             
              <FormGroup>
              
							{
								_.map(centervalue, (obj, index)=>{
								return(
									<FormControl 
									type='text'
									onChange={(e)=>this.handleOptionChangeCenter(e, index)}
									value={obj.label}
									label={obj.label}																
							  />
								)
							  })
							}						
  
							<span className="cursorPointer" onClick={this.addMoreCenters}>Add More</span>
							</FormGroup>
              <Button className="cursorPointer" onClick={this.UpDateCenterName}>Add</Button>
              </p>
              </Modal.Body>
              </Modal>
               : null }
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="1">
        <Card.Body>
          {this.centerNames()}
        </Card.Body>
        </Accordion.Collapse>
        </Card>
        <Card>
        <Accordion.Toggle as={Card.Header} eventKey="2">
          Client 
          <i class="fas fa-plus-circle accord" onClick={this.handleShowClients}/>
          {this.state.isClients ?          
            <Modal
            show={this.state.isClients}
            onHide={this.closeClients}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            >
            <Modal.Header closeButton>
            <ModalTitle> 
              Client Name</ModalTitle> 
            </Modal.Header>  
            <Modal.Body>
            <p>             
            <FormGroup>
            {
              _.map(clientvalue, (obj, index)=>{
              return(
                <FormControl 
                type='text'
                onChange={(e)=>this.handleOptionChangeClient(e, index)}
                value={obj.label}
                label={obj.label}																
              />
              )
              })
            }	
            <span className="cursorPointer" onClick={this.addMoreClients}>Add More</span>
            </FormGroup>
            <Button className="cursorPointer" onClick={this.UpDateClientName}>Add</Button>
            </p>
            </Modal.Body>
            </Modal>
             : null }
        </Accordion.Toggle>
      <Accordion.Collapse eventKey="2">
        <Card.Body>
          {this.clientNames()}
        </Card.Body>
        </Accordion.Collapse>
        </Card>
      <Card>
      <Accordion.Toggle as={Card.Header} eventKey="3">
          Process 
          <i class="fas fa-plus-circle accord" onClick={()=>this.handleShow('process')} />
          {/* <Delete delete={'Process'} Content={this.props.process} onActive={this.props.action.actionprocessedit}
           onUpdate={this.props.action.actionprocessUpdate}/> */}
          {showprocess ?
              <Modal
              show={this.state.showprocess}
              onHide={()=>this.handleHide('process')}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              >
              <Modal.Header closeButton>
                <ModalTitle>  
                Process Name  </ModalTitle>         
              </Modal.Header>  
              <Modal.Body>
              <p>             
              <FormGroup>
							<FormLabel>Process</FormLabel> 
             
							{
								_.map(processvalue, (obj, index)=>{
								return(
									<FormControl 
									type='text'
									onChange={(e)=>this.handleOptionChangeProcess(e, index)}
									value={obj.label}
									label={obj.label}																
							  />
								)
							  })
							}						
  
							<span className="cursorPointer" onClick={this.addMoreProcess}>Add More</span>
							</FormGroup>
              <Button className="cursorPointer" onClick={this.UpDateProcessName}>Add</Button>
              </p>
              </Modal.Body>
              </Modal>
               : null }
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="3">
        <Card.Body>
          {this.processNames()}
        </Card.Body>
        </Accordion.Collapse>
        </Card>
        <Card>
      <Accordion.Toggle as={Card.Header} eventKey="5">
            Categories
          <i class="fas fa-plus-circle accord" onClick={()=>this.handleShow('Catagories')} />
         
          {this.state.showCatagories ?
              <Modal
              show={this.state.showCatagories}
              onHide={()=>this.handleHide('Catagories')}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              >
              <Modal.Header closeButton>   
              <Modal.Title> Catagories  </Modal.Title>      
              </Modal.Header>  
              <Modal.Body>
              <p>             
              <FormGroup>
							{
								_.map(categoriesValue, (obj, index)=>{
								return(
									<FormControl 
									type='text'
									onChange={(e)=>this.handleOptionChangeCategories(e, index)}
									value={obj.label}
									label={obj.label}																
							  />
								)
							  })
							}						
  
							<span className="cursorPointer" onClick={this.addMoreCategories}>Add More</span>
							</FormGroup>
              <Button className="cursorPointer" onClick={this.UpDateCategories}>Add</Button>
              </p>
              </Modal.Body>
              </Modal>
               : null }
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="5">
        <Card.Body>
          {this.Categories()}
        </Card.Body>
        </Accordion.Collapse>
        </Card>


      </Accordion>
    </div>)
    } 
}